import React, { useState } from "react";
import backicon from './../../../../../Assets/icons/backIcon.svg'
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";

const CustomerInputs = [
  // {
  //   name: "leadtype",
  //   label: "Lead Type",
  //   type: "multiselectdropdown",
  //   required: true,
  //   validation: { required: true },
  //   options: [
  //       { label: "Hot Lead", value: "hot" },
  //       { label: "Cold Lead", value: "cold" },
  //       { label: "Warm Lead", value: "warm" },
        
  //     ],
  //   gridClass: "col-lg-4",
  // },
  {
    name: "leadname",
    label: "Lead Name",
    type: "text",
    required: true,
    validation: { required: true, maxLength:25 },
    gridClass: "col-lg-4",
  },
  {
    name: "mobile",
    label: "Mobile No.",
    type: "text",
    required: true,
    validation: { 
      required: true, pattern: /^[6-9]/ ,
      minLength:10,
      maxLength:10,
      message1: "Contact no should start with 6, 7, 8, 9",
      message: "Please enter a valid 10-digit",
    },
    errorMessage: "Please enter a valid 10-digit mobile number",
    gridClass: "col-lg-4",
  },
  {
    name: "productname",
    label: "Product Name",
    type: "text",
    validation: { required: true,  maxLength:25 },
    required: true,
   
    gridClass: "col-lg-4",
  },
  {
    name: "make",
    label: "Make",
    type: "text",
    required: true,
    validation: { required: true },
    gridClass: "col-lg-4",
  },
  {
    name: "model",
    label: "Model",
    type: "text",
    required: true,
    validation: { required: true },
   
    gridClass: "col-lg-4",
  },
  {
    name: "variant",
    label: "Variant",
    type: "text",
    required: true,
   validation: { required: true },
    gridClass: "col-lg-4",
  },
  {
    name: "color",
    label: "Color",
    type: "text",
    required: true,
   
    gridClass: "col-lg-4",
  },
  {
    name: "source",
    label: "Source",
    type: "text",
    required: true,
   validation: { required: true },
    gridClass: "col-lg-4",
  },
  {
    name: "status",
    label: "Status",
    type: "multiselectdropdown",
    required: true,
    options: [
        { label: "active", value: "Active" },
        { label: "inactive", value: "IN-Active" },
        
      ],
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  
];


const AddNewLead = () => {
 // alert("called")
  const [formData, setFormData] = useState({});
  const [validationErrors,setValidationErrors] = useState({})
 
const navigate=useNavigate()
  const handleFormSubmit = (data) => {
   
    console.log("Form Data:", data);
  
  };
 


  return (
    <>
      <div className="backbutton mt-2 mb-2" onClick={()=>navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle" >Add Lead</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Lead Details
        </span>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
       
        
      </div>
    
      <div className="btncontainer mt-3">
      <button
  onClick={() => {
   
      handleFormSubmit(formData); 
   
       
    
  }}
  className="submit-btn"
>
  Submit
</button>

        </div>
    </>
  );
};

export default AddNewLead;
